<main class="container">
  <section class="col-8 mx-auto text-center">
    <header>
      <h1>Complete Headline</h1>
    </header>

    <div class="row">
      <div class="col-4 mx-auto">
        <div class="jumbotron">
          <h3 class="display-3">75%</h3>
          <h4>
            Accuracy<br>
            <i class="fa fa-bullseye"></i>
          </h4>
        </div>
      </div>

      <div class="col-8">
        <form>
          <div class="form-group">
            <label for="exerciseOpenAnswer" class="sr-only">Email address</label>
            <textarea class="form-control" id="exerciseOpenAnswer" rows="8" placeholder="Open Answer Placeholder"></textarea>
          </div>
          <button type="submit" class="btn btn-primary btn-block">Submit</button>
        </form>
      </div>
    </div>

    <p class="lead">Complete copy / open answer prompt. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ut convallis libero, eu ultrices quam. Quisque vitae purus non urna sollicitudin ultrices in nec est.</p>
    <div class="row mt-5">
      <div class="col-5 offset-1">
        <button class="btn btn-success btn-lg btn-block">Persistence Round</button>
      </div>
      <div class="col-5">
        <a class="btn btn-primary btn-lg btn-block" [routerLink]="['/exercise/conclude']">Exercise Complete</a>
      </div>
    </div>
  </section>
</main>
